<template>
  <div class="row">
    <div class="col-lg-4">
      <div class="widget widget-primary">
        <div class="widget-label">Total Agreed</div>
        <div class="widget-value">
          {{ totalAgreed | currency('£', false) }}
        </div>
        <div class="widget-label">
          (Inc VAT) {{ totalAgreedWithVat | currency('£', false) }}
        </div>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="widget widget-primary">
        <div class="widget-label">Total Paid</div>
        <div class="widget-value">
          {{ totalPaid | currency('£', false) }}
        </div>
        <div class="widget-label">&nbsp;</div>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="widget widget-primary">
        <div class="widget-label">Total Outstanding</div>
        <div class="widget-value">
          {{ totalOutstanding | currency('£', false) }}
        </div>
        <div class="widget-label">&nbsp;</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    recovery: {
      type: Object,
      required: true
    },
    payments: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      totalAgreed: 0,
      totalAgreedWithVat: 0,
      totalPaid: 0,
      totalOutstanding: 0
    };
  },

  mounted() {
    this.setTotals();
  },

  methods: {
    setTotals() {
      if (this.recovery) {
        this.totalAgreed = this.recovery?.totals?.reduce(
          (total, value) => total + value.agreed_value,
          0
        );
        this.totalAgreedWithVat =
          this.recovery?.totals?.reduce(
            (total, value) => total + value.agreed_value_vat,
            0
          ) + this.totalAgreed;
        this.totalPaid = this.payments.reduce(
          (total, payment) => total + payment.value,
          0
        );
        this.totalOutstanding =
          (this.recovery.include_vat
            ? this.totalAgreedWithVat
            : this.totalAgreed) - this.totalPaid;
      }
    }
  },

  watch: {
    recovery() {
      this.setTotals();
    }
  }
};
</script>
